import { useCallback } from 'react'
import effects from 'app/effects/effects'
import { useFetcher } from 'libs/fetcher'
import * as R from 'ramda'

const VOUCHER_STATUS_ACTIVE = 1
const initialState = []

const useVoucherAttachment = (props) => {
  const { isOpen } = props
  const fetcher = useCallback(
    () =>
      effects.apis
        .getDealsPromotionList({
          page: 1,
          limit: 999,
          status: VOUCHER_STATUS_ACTIVE,
          sort: 'name:ASC',
        })
        .then(R.prop('data')),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen],
  )

  const { values, isLoading, errors } = useFetcher(fetcher, initialState)

  return {
    isLoading,
    vouchers: values,
    errors,
  }
}

export default useVoucherAttachment
